import OverlappingPlannedBreaks from "components/pages/schedule/helpers/OverlappingPlannedBreaks";
import DateTime from "utils/DateTime";
import Timespan from "utils/Timespan";

const WorkBlockFactory = {
  buildWithBlockTime,
  buildWithWorkTime,
  overlappingPlannedBreaks,
  overlappingPlannedBreaksDuration,
  updateBlock,
  workTime,
};

function buildWithBlockTime(workBlock) {
  const { startsAt, endsAt, teardownTimeDuration } = workBlock;

  _validateType(workBlock);

  return _build({
    ...workBlock,
    workTimeEndsAt: DateTime.subtractDuration(endsAt, teardownTimeDuration, "seconds"),
    workTimeStartsAt: startsAt,
  });
}

function buildWithWorkTime(workBlock) {
  const { workTimeStartsAt, workTimeEndsAt, teardownTimeDuration } = workBlock;

  _validateType(workBlock);

  return _build({
    ...workBlock,
    endsAt: DateTime.addDuration(workTimeEndsAt, teardownTimeDuration, "seconds"),
    startsAt: workTimeStartsAt,
  });
}

function updateOverlappingPlannedBreaks(workBlock) {
  const newWorkBlock = { ...workBlock };

  const isInProgressOrFuture = DateTime.isInTheFuture(newWorkBlock.endsAt);
  if (isInProgressOrFuture) {
    newWorkBlock.overlappingPlannedBreaks = overlappingPlannedBreaks(newWorkBlock);
  }

  return newWorkBlock;
}

function updateBlock(workBlock, updateProps) {
  const newWorkBlock = {
    ...workBlock,
    ...updateProps,
  };

  if ("startsAt" in updateProps) {
    newWorkBlock.workTimeStartsAt = updateProps.startsAt;
  }

  if ("workTimeStartsAt" in updateProps) {
    newWorkBlock.startsAt = updateProps.workTimeStartsAt;
  }

  if ("teardownTimeDuration" in updateProps || "workTimeEndsAt" in updateProps) {
    newWorkBlock.endsAt = DateTime.addDuration(
      newWorkBlock.workTimeEndsAt,
      newWorkBlock.teardownTimeDuration,
      "seconds",
    );
  }

  if ("endsAt" in updateProps) {
    newWorkBlock.workTimeEndsAt = DateTime.subtractDuration(
      newWorkBlock.endsAt,
      newWorkBlock.teardownTimeDuration,
      "seconds",
    );
  }

  return updateOverlappingPlannedBreaks(newWorkBlock);
}

function overlappingPlannedBreaks(workBlock) {
  const breaks = new OverlappingPlannedBreaks({
    line: workBlock.line,
  });

  return breaks.getCombinedOverlappingPlannedBreaks(workTime(workBlock));
}

function workTime(workBlock) {
  const { workTimeStartsAt, workTimeEndsAt } = workBlock;

  return new Timespan(new Date(workTimeStartsAt), new Date(workTimeEndsAt));
}

function overlappingPlannedBreaksDuration(workBlock) {
  return overlappingPlannedBreaks(workBlock).reduce((partialSum, item) => partialSum + item.duration, 0);
}

function _build(workBlock) {
  const newWorkBlock = {
    jobId: null,
    overlappingPlannedBreaks: [],
    teardownTimeDuration: 0,
    teardownTimeLabel: "Teardown Time",
    ...workBlock,
    __typename: "WorkBlock",
  };

  return updateOverlappingPlannedBreaks(newWorkBlock);
}

function _validateType(workBlock) {
  if (workBlock.__typename && workBlock.__typename !== "WorkBlock") {
    throw new Error(`Attempt to build WorkBlock with object of different type: ${workBlock.__typename}`);
  }
}

export default WorkBlockFactory;
